// Components
import Flex from '@components/helpers/flex/Flex'
import Span from '@components/helpers/text/Span'
import Text from '@components/helpers/text/Text'

// Styles
import styles from './Selection.module.sass'

interface SelectionCounterProps {
  text: string
  selected: number
  total: number
}

const SelectionCounter = ({ text, selected, total }: SelectionCounterProps) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      className={styles.selectionCounter}
    >
      <Text tagName="h2" variant="title-7">
        {text}
      </Text>
      <Text
        tagName="p"
        variant="title-7"
        color={selected == total ? 'pink' : 'grey'}
      >
        <Span>{selected}</Span>
        <Span>&nbsp;/&nbsp;</Span>
        <Span>{total}</Span>
      </Text>
    </Flex>
  )
}

export default SelectionCounter
